import * as React from 'react'
import {ErrorComponentProps} from '@eda.yandex/web-router'
import {RouterEnv} from 'admin/types'

type Props = ErrorComponentProps<RouterEnv>

export default class DefaultErrorComponent extends React.Component<Props> {
  render () {
    return (
      <div>
        Что-то пошло не так, но мы уже знаем об этом и спешим на помощь.
        <br/>
        Попробуйте начать с главной страницы или повторить ваш запрос позже.
      </div>
    )
  }
}
